import { IonicModule } from "@ionic/angular";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CashierPage } from "./cashier.page";

@NgModule({
  imports: [IonicModule, CommonModule, FormsModule],
  declarations: [CashierPage],
  exports: [CashierPage],
})
export class CashierPageModule {}
